import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BarChart3, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import "./HomePolls.css";

export default function HomePollsResults() {
  const [polls, setPolls] = useState([]);

  useEffect(() => {
    api.get("/polls/results").then((r) => setPolls(r.data || [])).catch(() => setPolls([]));
  }, []);

  if (!polls.length) return null;

  return (
    <section className="polls-mod polls-results-mod" data-testid="home-polls-results">
      <header className="polls-head">
        <BarChart3 size={26} className="polls-icon" />
        <div>
          <h2 className="polls-title">RESULTADOS DE ENCUESTAS</h2>
          <p className="polls-sub">Lo que dijo la gente</p>
        </div>
      </header>
      <div className="polls-results-grid">
        {polls.slice(0, 4).map((p) => (
          <div key={p.id} className="poll-result-card">
            {p.image && <img src={p.image} alt={p.title} className="poll-result-hero" />}
            <div className="poll-result-body">
              <h3 className="poll-result-title">{p.title}</h3>
              <p className="poll-result-total">{p.total_votes} {p.total_votes === 1 ? "voto" : "votos"}</p>
              <ul className="poll-result-list">
                {(p.options || []).slice(0, 5).map((o, i) => (
                  <li key={o.id} className={`poll-result-row ${i === 0 ? "winner" : ""}`}>
                    <div className="poll-result-row-head">
                      <span className="poll-result-opt-text">
                        {o.text}
                      </span>
                      <span className="poll-result-pct">{o.pct.toFixed(1)}%</span>
                    </div>
                    <div className="poll-result-bar">
                      <div className="poll-result-fill" style={{ width: `${o.pct}%` }} />
                    </div>
                    <span className="poll-result-votes">{o.votes} {o.votes === 1 ? "voto" : "votos"}</span>
                  </li>
                ))}
              </ul>
              <Link to={`/encuesta/${p.slug}/resultados`} className="poll-result-cta" data-testid={`poll-result-cta-${p.slug}`}>
                Ver detalle <ArrowRight size={12} />
              </Link>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
